import type { HTMLAttributes } from "react";

import { cn } from "../../utils";

export type DialogFooterProps = HTMLAttributes<HTMLDivElement>;

const Footer = ({ className, ...props }: DialogFooterProps) => (
  <div className={cn("flex flex-1 justify-end gap-2 px-6 pt-4", className)} {...props} />
);

Footer.displayName = "Footer";

export default Footer;
